export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA_60X1207.4e2f3bb6.jpg";